import {Pipe, PipeTransform} from '@angular/core';
import {RouteService} from '../services/route.service';

@Pipe({
    name: 'route'
})
export class RoutePipe implements PipeTransform {
    constructor(private routeService: RouteService) {}

    transform(id: number): any {
        const routes = this.routeService.getRoute();
        return routes.find((el) => el.id === id);
    }
}
